var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexagons03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.25 503.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2489.67,
    y1: -5444.05,
    x2: -2059.06,
    y2: -5444.05,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#067eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2462.89,
    y1: -5444.05,
    x2: -2495.06,
    y2: -5444.05,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18c3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009de6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2538.89,
    y1: -5355.7,
    x2: -2190.25,
    y2: -5355.7,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#067eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#006391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2471.58,
    y1: -5355.7,
    x2: -2539.81,
    y2: -5355.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2490.86,
    y1: -5303.7,
    x2: -2036.01,
    y2: -5303.7,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2403.05,
    y1: -5303.7,
    x2: -2492.06,
    y2: -5303.7,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hexagons03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.72,487.3l11.46-8.11a6.88,6.88,0,0,0,1.42-4.54V74.87a6.87,6.87,0,0,0-1.42-4.53L228.72,58.09a1.78,1.78,0,0,0-2.84,0L214.42,70.34A6.87,6.87,0,0,0,213,74.87V474.65a6.88,6.88,0,0,0,1.42,4.54l11.46,8.11A1.79,1.79,0,0,0,228.72,487.3Z",
    transform: "translate(-213 -7.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.72,83.79l11.46-6.63a2.82,2.82,0,0,0,1.42-2.46V61.47A2.89,2.89,0,0,0,240.18,59l-11.46-6.62a2.83,2.83,0,0,0-2.84,0L214.42,59A2.83,2.83,0,0,0,213,61.47V74.7a2.87,2.87,0,0,0,1.42,2.46l11.46,6.63A2.88,2.88,0,0,0,228.72,83.79Z",
    transform: "translate(-213 -7.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.66,356,343,342.48a5.76,5.76,0,0,0,3-5V27.5a5.78,5.78,0,0,0-3-5L318.66,8.94a6.23,6.23,0,0,0-6,0L288.31,22.47a5.77,5.77,0,0,0-3,5v310a5.76,5.76,0,0,0,3,5L312.64,356A6.25,6.25,0,0,0,318.66,356Z",
    transform: "translate(-213 -7.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M318.66,74.67,343,60.62a6,6,0,0,0,3-5.21V27.31a6,6,0,0,0-3-5.21l-24.33-14a6,6,0,0,0-6,0L288.31,22.1a6,6,0,0,0-3,5.21v28.1a6,6,0,0,0,3,5.21l24.33,14.05A6,6,0,0,0,318.66,74.67Z",
    transform: "translate(-213 -7.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371.58,510l31.74-17.67a7.54,7.54,0,0,0,3.93-6.55V81.42a7.53,7.53,0,0,0-3.93-6.54L371.58,57.21a8.09,8.09,0,0,0-7.84,0L332,74.86a7.52,7.52,0,0,0-3.93,6.56v404.4a7.54,7.54,0,0,0,3.93,6.55L363.72,510A8.13,8.13,0,0,0,371.58,510Z",
    transform: "translate(-213 -7.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.58,143l31.74-18.34a7.85,7.85,0,0,0,3.93-6.79V81.17a7.85,7.85,0,0,0-3.93-6.79L371.58,56a7.89,7.89,0,0,0-7.84,0L332,74.38a7.85,7.85,0,0,0-3.93,6.79v36.67a7.85,7.85,0,0,0,3.93,6.79L363.72,143A7.93,7.93,0,0,0,371.58,143Z",
    transform: "translate(-213 -7.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagons03);
export default __webpack_public_path__ + "static/media/hexagons03.61bcf98cb5487042dd940867c3175133.svg";
export { ForwardRef as ReactComponent };